// export const logout = () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('user');
//     window.location.href = '/login'; // Çıkış yaptıktan sonra login sayfasına yönlendirin
// };
//

export const logout = (message = null) => {
    if (message) localStorage.setItem("logoutMessage", message);

    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("cart_guid");
};


export function getOrCreateCartGuid() {
    let guid = localStorage.getItem("cart_guid");
    if (!guid) {
        guid = crypto.randomUUID();
        localStorage.setItem("cart_guid", guid);
    }
    return guid;
}

export function clearCartGuid() {
    localStorage.removeItem("cart_guid");
}

// const storedUser = localStorage.getItem('user');
// const parsedUser = storedUser ? JSON.parse(storedUser) : null;
//
// localStorage.removeItem('token');
// localStorage.removeItem('user');
//
// if (parsedUser?.role === 'admin') {
//     window.location.href = '/admin';
// } else {
//     window.location.href = '/login';
// }
